import { hash01 } from '../rng';

/**
 * Tower facade styles (pure data; the renderer draws them in src/render/facadeStyles.ts). Every style
 * keeps the 500 cm module: a 36 cm pier, glass from 12% to 88% of the floor height. It varies the
 * spandrel and pier finish, the frame colour, the glass tint, and the mullions and transom inside
 * the 464 cm of glass. Colours are sRGB.
 */
export const FACADE_STYLES = [
  { name: 'blue curtain wall', spandrel: [0.58, 0.61, 0.65], pier: [0.62, 0.65, 0.69], frame: [0.5, 0.53, 0.56], glass: [0.5, 0.66, 0.84], mullions: 2, transom: false },
  { name: 'green ribbon', spandrel: [0.34, 0.4, 0.39], pier: [0.3, 0.35, 0.34], frame: [0.25, 0.28, 0.28], glass: [0.52, 0.78, 0.7], mullions: 1, transom: true },
  { name: 'concrete punched', spandrel: [0.78, 0.76, 0.71], pier: [0.74, 0.72, 0.67], frame: [0.35, 0.34, 0.33], glass: [0.62, 0.66, 0.7], mullions: 3, transom: true },
  { name: 'dark glass', spandrel: [0.13, 0.15, 0.18], pier: [0.1, 0.1, 0.11], frame: [0.08, 0.08, 0.09], glass: [0.38, 0.44, 0.5], mullions: 1, transom: false },
  { name: 'bronze', spandrel: [0.46, 0.36, 0.26], pier: [0.4, 0.31, 0.22], frame: [0.3, 0.23, 0.16], glass: [0.78, 0.64, 0.46], mullions: 2, transom: false },
  { name: 'brick-clad office', spandrel: [0.56, 0.31, 0.24], pier: [0.52, 0.29, 0.22], frame: [0.85, 0.84, 0.8], glass: [0.62, 0.68, 0.74], mullions: 2, transom: true },
] as const;

/** A tower's facade style index (deterministic per tower). */
export function towerStyle(seed: number, id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  return Math.floor(hash01(seed, h, 4441) * FACADE_STYLES.length);
}
